
import { defineComponent, reactive, ref, computed } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { SMUser } from "@/store";
import { emailRules, isEmailValid } from "@/utils/validator";

export default defineComponent({
  name: "PaidConsultationForm",

  components: {
    Popup: () => import("@/modules/Pricing/Popup/Popup.vue"),
    FormsTemplate: () => import("@/modules/Pricing/Services/Forms/FormsTemplate.vue"),
  },

  emits: ["ok", "cancel", "close"],

  setup(_, { emit }) {
    const data = reactive({
      service_type: "paid_consultation",
      employer_name:
        `${SMUser.user?.title} ${SMUser.user?.first_name} ${SMUser.user.last_name}` || "",
      phone: `${SMUser.user?.phone}` || "",
      email: `${SMUser.user?.email}` || "",
      company_name: `${SMUser.user?.company?.CompanyProfile?.name}` || "",
      additional: {
        preferred_date: "",
        notes: "",
      },
    });

    const isPopoverOpen = ref(true);

    const onOk = () => {
      emit("ok");
    };

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    const onClose = () => {
      isPopoverOpen.value = false;

      emit("close");
    };

    const isFormComplete = computed(() => {
      const topLevelRequiredFields = [
        data.employer_name,
        data.phone,
        data.email,
        data.company_name,
        data.additional.preferred_date,
        data.additional.notes,
      ];

      return (
        isEmailValid.value &&
        topLevelRequiredFields.every((val) => !!val && String(val).trim().length > 0)
      );
    });

    const loading = ref(false);

    async function submitServiceRequest() {
      try {
        loading.value = true;

        await axios.post(API_ROUTES.SUBMIT_SERVICE_REQUEST, data);
      } catch (error) {
        console.log("SUBMIT_SERVICE_REQUEST failed", error);
      } finally {
        loading.value = false;

        onOk();
      }
    }

    const emailValidationRules = emailRules;

    return {
      data,
      isPopoverOpen,
      onOk,
      onCancel,
      onClose,
      isFormComplete,
      loading,
      submitServiceRequest,
      emailValidationRules,
    };
  },
});
